<template>
	<div>
		<h1>Iris flower <small> data set</small></h1>
	

	<!-- begin row -->
		<div class="row">
				<!-- begin col-6 -->
			<div class="col-lg-6">
				<!-- begin panel -->
				<panel title="Bar Chart">
					<div class="height-sm">
						<vn-bar :model="barChart.data"
							textField="label"
							valueField="value"
							:staggerLabels="barChart.staggerLabels"
							x-format=",.1f"
							y-format=",.2f">
						</vn-bar>
					</div>
				</panel>
				<!-- end panel -->
			</div>
			<!-- end col-6 -->
						<!-- begin col-6 -->
			<div class="col-lg-6">
				<!-- begin panel -->
				<panel title=" Attribute Information">
					<div class="height-sm">
					<p>Attribute Information: </p>
						<ol >
							<li> <span class="label label-inverse"> sepal length in cm</span> </li>
							<li> <span class="label label-green"> sepal width in cm</span> </li>
							<li><span class="label label-lime">  petal length in cm</span> </li>
							<li> <span class="label label-yellow"> petal width in cm </span> </li>
								<li> class: 
								<ul class="fa-ul">
									<li><span class="fa-li"><i class="fas fa-spinner fa-pulse"></i></span>
										<span class="badge badge-green"> Iris Setosa </span> 
									</li>
									<li>
										<span class="fa-li"><i class="fas fa-sync fa-spin"></i></span>
										<span class="badge badge-lime"> Iris Versicolour </span> 
										</li>
									<li>
										<span class="fa-li"><i class="fas fa-cog fa-spin"></i></span>
										<span class="badge badge-yellow"> Iris Virginica </span> 
									</li>
								</ul></li>
						</ol>	

						<!-- animated -->
						<div class="progress rounded-corner progress-striped active">
						<div class="progress-bar bg-purple" style="width: 80%">
							Animated
						</div>
						</div>		
					</div>
				</panel>
				<!-- end panel -->
			</div>
			<!-- end col-6 -->


			  <div class="col-lg-6">
                <!-- begin panel -->
                <panel title="Test" bodyClass="p-t-0">
                    <vue-good-table :columns="columns" :rows="rows" :lineNumbers="true" :search-options="{ enabled: true, placeholder: 'Search this table' }"
                        :pagination-options="{ enabled: true,  position: 'bottom' }" :selectOptions="{
				enabled: true,
				selectOnCheckboxOnly: true,
				selectionInfoClass: 'alert alert-info m-b-0 no-rounded-corner',
				selectionText: 'rows selected',
				clearSelectionText: 'clear',
			}">
                        <div slot="selected-row-actions" style="margin: -2px 0;">
                            <button class="btn btn-xs btn-primary m-r-5">Action 1</button>
                            <button class="btn btn-xs btn-grey">Action 2</button>
                        </div>
                        <template slot="table-row" slot-scope="props">
                            <span v-if="props.column.field == 'image'">
                                <img v-bind:src="props.row.image" class="rounded" width="24" style="margin: -3px" />
                            </span>
                            <span v-else>
                                {{props.formattedRow[props.column.field]}}
                            </span>
                        </template>
                    </vue-good-table>
                </panel>
            </div>
		</div>
</div>

</template>

<script>
export default {
  data() {
    var barChartData = [
      {
        key: "Cumulative Return",
        values: [
          { label: "Iris Setosa", value: 29, color: "#ff5b57" },
          { label: "Iris Versicolour ", value: 15, color: "#f59c1a" },
          { label: "Iris Virginica", value: 32, color: "#00ACAC" }
        ]
      }
    ];

    var rowData = [];

    for (var i = 0; i < 150; i++) {
      rowData.push({ cislo: i, cislo2: i - 30, haha: i * 30 });
    }

    return {
      barChart: {
        data: barChartData,
        staggerLabels: false
      },
      columns: [
        {
          label: "cislo",
          field: "cislo",
          type: "number",
          thClass: "text-nowrap",
          tdClass: "text-nowrap"
        },
        {
          label: "cislo2",
          field: "cislo2",
          type: "number",
          thClass: "text-nowrap",
          tdClass: "text-nowrap"
        },
        {
          label: "haha",
          field: "haha",
          type: "number",
          thClass: "text-nowrap",
          tdClass: "text-nowrap"
        }
      ],
      rows: rowData
    };
  }
};
</script>